// ** Component Imports
import { SUBSCRIPTION_PAGE_PATH } from './FreePlanUpgradeButton'

/**
 * Toast body for the backend's free-plan client limit. Toasts render outside
 * the router, so the upgrade action is a plain link.
 */
export const FreePlanLimitToast = ({ message }: { message: string }) => (
	<div className='flex flex-col gap-1'>
		<span>{message}</span>
		<a
			href={SUBSCRIPTION_PAGE_PATH}
			className='font-semibold text-primary underline'
		>
			Upgrade
		</a>
	</div>
)
